const colors = {
	gray100: 'rgb(246, 248, 250)',
	gray200: 'rgb(234, 236, 239)',
	gray300: 'rgb(208, 215, 222)',
	gray400: 'rgb(140, 149, 159)',
	gray500: 'rgb(107 114 128)',
	gray600: 'rgb(88, 96, 105)',
	gray700: 'rgb(55 65 81)',
	gray800: 'rgb(36, 41, 47)',
	gray900: 'rgb(17 24 39)',
	blue100: 'rgb(191 219 254)',
	blue200: 'rgb(147 197 253)',
	blue300: 'rgb(96 165 250)',
	blue400: 'rgb(59 130 246)',
	blue500: 'rgb(37 99 235)',
	blue600: 'rgb(29 78 216)',
	blue700: 'rgb(30 64 175)',
	blue800: 'rgb(9, 105, 218)',
	blue900: 'rgb(17, 24, 39)',
	green800: 'rgb(26, 127, 55)',
	purple500: ' rgb(130, 80, 223)',
	red600: 'rgb(207, 34, 46)',
	primaryGreen: '#2da44e',
};

export default colors;
